import { Component, inject, OnInit } from '@angular/core';
import { KpiWidgetComponent } from '../../../../../_shared/components/kpi-widget/kpi-widget.component';
import { BaseWidgetComponent } from '../../../../../home/home-widgets/widgets/base-widget.component';
import { FilterService } from '../../../../../_shared/services/filter.service';
import { AccountDateFilterRequest } from '../../../../../_shared/models/accountDateFilter.model';
import { AssetOverviewService } from '../../../services/asset-overview.service';
import { ErrorHandlerService } from '../../../../../_shared/services/error-handler.service';
import { TranslocoService } from '@jsverse/transloco';

@Component({
  selector: 'app-total-assets',
  standalone: true,
  imports: [KpiWidgetComponent],
  templateUrl: './total-assets.component.html',
  styleUrl: './total-assets.component.scss'
})
export class TotalAssetsComponent extends BaseWidgetComponent {
  hasError: boolean = false;
  errorMessage: string = '';

  private assetOverviewService = inject(AssetOverviewService);
  private errorHandlerService = inject(ErrorHandlerService);
  private readonly transloco: TranslocoService = inject(TranslocoService);

  constructor() {
    const filterService: FilterService = inject(FilterService);
    super(filterService);
    this.title = this.transloco.translate('assetOverview.widgets.totalAssets');
    this.isLoading = true;
    this.value = 0;
    this.percentageDifference = 0;
  }

  protected override async onFilterChangeAsync(): Promise<void> {
    this.isLoading = true;
    this.hasError = false;
    this.errorMessage = '';

    try {
      const request: AccountDateFilterRequest = {
        accountIds: this.widgetFilter.accountIds,
        timeFrom: this.widgetFilter.startDate!,
        timeTo: this.widgetFilter.endDate!
      };

      this.cancelSubject.next();
      const response = await this.assetOverviewService.getTotalAssets(request, this.cancelSubject);
      this.value = response.data?.totalAssets ?? 0;

      this.isLoading = false;
    } catch (error) {
      this.errorHandlerService.handleError(error, {
        callback: (message) => {
          this.errorMessage = message;
          this.hasError = true;
          this.isLoading = false;
        }
      });
    }
  }

  public override formatValue(value: number): string {
    return `${value.toLocaleString()}`;
  }
}